import { getDaysInMonth } from "date-fns";

export function getValidDayInMonth(year: number, month: number, day: number): number {
  return Math.min(Math.max(day, 1), getDaysInMonth(new Date(year, month)));
}
